
























































import { computed, defineComponent, inject, PropType, ref, toRef, watch } from "@vue/composition-api";
import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import { TipSubjectType } from "@scrile/api-provider/dist/api/TipProvider";
import useAuthorisedOnly from "@/hooks/useAuthorisedOnly";
import useRole from "@/hooks/useRole";
import providers from "@/lib/api";
import { handleRequestError } from "@/lib/handleRequestError";
import { currencySymbol } from "@/lib/moneyHelpers";
import { ERRORS, PROVIDED_DATA, PROVIDED_DATA_KEY } from "@/const";
import BaseIcon from "@/components/BaseIcon";
import BaseInput from "@/components/BaseInput";
import BaseSpinner from "@/components/BaseSpinner";
import PaidActionError from "@/components/PaidActionError";
import { regexInput } from "./const";

export default defineComponent({
  name: "TipController",
  components: { BaseSpinner, BaseInput, BaseIcon, PaidActionError },
  props: {
    transparent: { type: Boolean, default: false },
    subject: { type: Object as PropType<Subject<TipSubjectType>>, required: true },
    userId: { type: String },
  },
  setup(props, { emit }) {
    const data = inject<PROVIDED_DATA[PROVIDED_DATA_KEY.OPPONENT_USER]>(PROVIDED_DATA_KEY.OPPONENT_USER, {
      user: null,
    });

    const { isCreator: isOpponentCreator } = useRole(toRef(data, "user"));

    const tipValue = ref("");
    const processing = ref(false);
    const show = ref(false);
    const showPaidError = ref(false);

    const userId = computed(() => props.userId ?? data.user?.id ?? "");
    const activateTip = computed(() => isOpponentCreator.value);
    const openerIcon = computed(() => (show.value ? "sci-close" : "sci-gift"));
    const allowSend = computed(() => tipValue.value.length !== 0 && +tipValue.value > 0);

    const toggleShow = useAuthorisedOnly(() => (show.value = !show.value));
    watch(show, () => {
      tipValue.value = "";
    });

    const tipValueInput = (v: string) => {
      const value = Number(v.replace(currencySymbol, "") ?? 0) || 0;
      if (isNaN(value) || value === 0) {
        tipValue.value = "";
      } else {
        tipValue.value = value.toString();
      }
    };

    const submit = async () => {
      if (!userId.value || !allowSend.value) return;
      try {
        processing.value = true;
        const tipAmount = tipValue.value;
        providers.TipProvider.setReceiveErrors(false);
        await providers.TipProvider.create({
          data: {
            amount: +tipAmount,
            subject: props.subject,
          },
        });
        emit("success");
        tipValue.value = "";
        show.value = false;
      } catch (e) {
        handleRequestError(e, [
          {
            comparator: e => e.details?.messageTemplate === ERRORS.SPENDING_BALANCE,
            onSuccessCB: () => (showPaidError.value = true),
          },
        ]);
      } finally {
        processing.value = false;
        tipValue.value = "";
      }
    };

    return {
      currencySymbol,
      tipValue,
      tipValueInput,
      allowSend,
      processing,
      submit,
      activateTip,
      openerIcon,
      show,
      toggleShow,
      showPaidError,
      regexInput,
    };
  },
});
